module.exports = __webpack_public_path__ + "media/src/images/icon/tel-193778da7fc5409697e6046dc8fddf61.png";